import script from "./VACardRest.vue?vue&type=script&setup=true&lang=ts"
export * from "./VACardRest.vue?vue&type=script&setup=true&lang=ts"

import "./VACardRest.vue?vue&type=style&index=0&id=107cc6b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-107cc6b8"]])

export default __exports__